 function getStatusBarHeight() {
    let statusBarHeight = 0;
  
    if (window.visualViewport) {
      statusBarHeight = window.visualViewport.offsetTop;
    } else if (window.screen && window.matchMedia('(display-cutout: constant)').matches) {
      const devicePixelRatio = window.devicePixelRatio;
      const screenHeight = window.screen.height;
      statusBarHeight = Math.round(24 * devicePixelRatio); // 这里的24需要根据设备实际情况进行调整
    }
  
    return statusBarHeight;
  }
  
  const statusBarHeight = getStatusBarHeight();
  // console.log('状态栏高度：', statusBarHeight);
localStorage.setItem('statusBarHeight', statusBarHeight);  
  export default statusBarHeight;


// WEBPACK FOOTER //
// ./src/utils/StarisBarHeight.js